import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from "../../store/actions/todoActions";

import { useDispatch } from "react-redux";

import moment from "moment/moment";
import Datepicker from "react-tailwindcss-datepicker";
import ConditionalRender from "../../components/Common/ConditionalRender";
import { formatRupiah } from "../../components/Common/utils";
import Button from "../../components/Common/Button";

function LogSaldo() {
    const isLogin = localStorage.getItem("isLogin");
    const [logSaldoData, setlogSaldoData] = useState([]);

    const [LogSaldoLoading, setPesananRealtimeLoading] = useState(true);
    const [itemsPerPage] = useState(12);
    const [currentPage, setCurrentPage] = useState(0);
    const [value, setValue] = useState({
        startDate: new Date(),
        endDate: new Date().setMonth(11),
    });

    const statusJSON =
        '[{"text": "Semua", "value": "0"},{"text": "Plus", "value": "1"},{"text": "Minus", "value": "2"}]';
    const [status, setStatus] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(isIdTarget(undefined));
    }, [dispatch]);

    useEffect(() => {
        const formattedstartDate = moment(new Date(value.startDate)).format(
            "YYYY-MM-DD"
        );
        const formattedendDate = moment(new Date(value.endDate)).format(
            "YYYY-MM-DD"
        );
        if (isLogin) {
            const parseLogin = JSON.parse(isLogin);
            fetchLogSaldo(parseLogin?.apiKey, parseLogin?.token, formattedstartDate, formattedendDate);
        }
    }, [value, currentPage]);

    const fetchLogSaldo = async (api_key, token, startDate, endDate) => {
        setPesananRealtimeLoading(true);
        try {

            const response = await ApiService({
                baseurl: "user/logSaldo",
                parameter: "api_key=" +
                    api_key +
                    "&start_date=" +
                    startDate +
                    "&end_date=" +
                    endDate +
                    "&page=" +
                    currentPage +
                    "&limit=" +
                    itemsPerPage,
                method: "GET",
                XGORDON: "LOGSALDO",
                token: token,
            });
            setPesananRealtimeLoading(false);
            if (response?.statusCode === 200) {
                setlogSaldoData(response.result.data);
            } else {
                setlogSaldoData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleNextPage = () => {
        setCurrentPage((halamanSebelumnya) => halamanSebelumnya + itemsPerPage);
    };

    const handlePreviousPage = () => {
        if (currentPage > 0) {
            setCurrentPage((halamanSebelumnya) => halamanSebelumnya - itemsPerPage);
        }
    };

    return (
        <div className="flex flex-col gap-3 flex-1 relative m-2">
            <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner  bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
                <div className="flex flex-col gap-2 justify-center flex-1 p-3">
                    <span className="text-[#22BDE2] text-2xl font-bold"> Log Saldo
                    </span>
                    <span className=" text-base font-light flex-1">
                        Ini adalah halaman untuk menampilkan semua pembelian produk kami.
                        Silakan pilih produk untuk melihat daftar pembelian. </span>

                    <div className="flex flex-col sm:flex-row justify-between gap-3 ">
                        <div className="outline rounded-md outline-[#22BDE2]  sm:w-56">
                            <Datepicker
                                value={value}
                                onChange={(a) => {
                                    setValue(a);
                                }}
                                showShortcuts={true}
                                classNames={"bg-red-400 "}
                                primaryColor={"blue"}
                                inputClassName={'text-[#22BDE2] px-3 bg-transparent w-full h-10'}

                            />
                        </div>
                        <div
                            className={`flex flex-row items-center justify-center py-1 px-3 rounded-md sm:w-44  outline-[#22BDE2] text-[#22BDE2] outline-2 outline cursor-pointer `}
                        >
                            <select
                                value={status}
                                onChange={(event) => {
                                    const inputValue = event.target.value;
                                    if (inputValue.length <= 200) {
                                        setStatus(inputValue);
                                        if (isLogin) {
                                            const parseLogin = JSON.parse(isLogin);
                                            fetchLogSaldo(parseLogin?.apiKey, parseLogin?.token, inputValue);
                                        }
                                        setCurrentPage(0)
                                    }
                                }}
                                className={`text-md cursor-pointer bg-transparent focus:outline-none focus:ring-0 w-full h-8`}
                            >
                                {JSON.parse(statusJSON).map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.text}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>
                </div>
                <div className="md:flex hidden flex-1">
                    <img
                        src={require('../../assets/images/pngwing 1.png')}
                        alt="Logo"
                        className="object-cover  object-right flex-1 h-full rounded-md" />
                </div>
            </div>
            <div className="flex flex-col gap-3 justify-betweenmin-h-[500px]" >
                <ConditionalRender
                    productsData={logSaldoData}
                    isLoading={LogSaldoLoading}
                    model={"emptyData"}
                >
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                        {logSaldoData.map((item, index) => (
                            <div key={index} >
                                <div
                                    className="flex flex-col rounded-lg p-2 h-full gap-2 bg-cardLight dark:bg-cardDark  shadow-inner "
                                >
                                    <div className="flex flex-row justify-between items-center ">
                                        <div className={`rounded-md border-1  p-1`}>

                                        </div>
                                        <span className="opacity-70 text-xs font-light line-clamp-1 ">
                                            {item.tanggal}
                                        </span>
                                    </div>
                                    <div className="flex flex-row justify-between items-center flex-1">
                                        <div className="flex flex-row gap-2 items-center">
                                            <div className="flex flex-col items-start">
                                                <span className={` text-base font-medium `}>
                                                    {item.keterangan}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-row justify-between items-end">
                                        <div className="flex flex-col">
                                            <span className="opacity-70 text-xs font-light line-clamp-1 ">
                                                Saldo Sebelum : {formatRupiah(item.saldo_sebelum)}
                                            </span>
                                            <span className="opacity-70 text-xs font-light line-clamp-1 ">
                                                Saldo Sesudah : {formatRupiah(item.saldo_sesudah)}
                                            </span>
                                        </div>
                                        <span className={` font-bold ${item.jenis === "minus"
                                            ? "text-[#F42536] border-[#F42536]"
                                            : item.jenis === "plus"
                                                ? "text-[#0ABE5D] border-[#0ABE5D]"
                                                : null
                                            } `}>
                                            {item.jenis === "minus" ? "-" : "+"}{formatRupiah(item.jumlah_saldo)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </ConditionalRender>
                <div className=" flex flex-row justify-center gap-2">
                    <Button
                        disabled={currentPage <= 0}
                        initialValue="Sebelumnya"
                        type="fill"
                        className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${currentPage <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => { handlePreviousPage() }}
                    />
                    <Button
                        disabled={logSaldoData.length === 0}
                        initialValue="Selanjutnya"
                        type="fill"
                        className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${logSaldoData.length <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => handleNextPage()}
                    />
                </div>
            </div>
        </div>
    );
}

export default LogSaldo;
